import React from 'react';
import PropTypes from 'prop-types';

class ColorPicker extends React.Component {
  static displayName = 'ColorPicker';

  static defaultProps = {
    disabled: false,
    name: '',
    value: ''
  };

  static propTypes = {
    name: PropTypes.string
  };

  onChange = (hex) => {
    let colorInt = this.hexToInt(hex);
    this.props.onChange(this.props.name, colorInt);
  };

  intToHex(color) {
    return '#' + color.toString(16);
  }

  hexToInt(hex) {
    return parseInt(hex.replace('#', ''), 16);
  }

  componentDidMount() {
    let defaultValue = this.intToHex(this.props.value);

    $(this.inputEl).minicolors({
      defaultValue: defaultValue,
      format: 'hex',
      change: this.onChange,
      theme: 'bootstrap'
    });
  }

  render() {
    return (
      <input
        name={this.props.name}
        style={{width: '100%'}}
        disabled={this.props.disabled}
        ref={(el) => {
          this.inputEl = el;
        }}
      />
    );
  }
}

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/js/Component/ColorPicker.jsx